import React, { useRef, useState } from "react";
import * as IoIcons from "react-icons/io";
import "../estilos.css";
import { Row, Label } from "reactstrap";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import QRGenerator from "../codereader/Qrgenerator";
import { useReactToPrint } from "react-to-print";
import Moment, { updateLocale } from "moment";

function EtiquetaViajeraPT({
  indice,
  reciba,
  mRecibas,
  tipo,
  bColor,
  btitle,
  llamada
}) {
  const [indexImp, setIndexImp] = useState(0);
  const cantidadAlmacen = tipo === "parcial" ? true : false;
  const componentRef = React.useMemo(
    () =>
      Array(500)
        .fill(0)
        .map((i) => React.createRef()),
    []
  );
  const handlePrint = useReactToPrint({
    content: () => componentRef[indexImp].current,
  });
  const componentRefTEV = useRef();
  const handlePrintTEV = useReactToPrint({
    content: () => componentRefTEV.current,
  });
  return (
    <>
      <button
        class={"btn-" + bColor + " cbutton"}
        title={btitle}
        //style={{ display: "none" }}
        onMouseDown={() => setIndexImp(indice)}
        onClick={() =>
          tipo === "todo" ? handlePrintTEV() : handlePrint(indice)
        }
      >
        <IoIcons.IoIosPrint /> {tipo === "todo" ? "Imprimir todo" : ""}
      </button>

      <div style={{ display: "none" }}>
        <div ref={componentRefTEV}>
          {
            reciba.activo && (
              <div ref={componentRef[indice]} id="rd1">
                {reciba.piezasenCuarentena > 0 &&
                  tipo === "parcial" &&
                  (llamada === "Cuarentena" || llamada === "Todo") && (
                    <>
                      <div className="page-breaksmtop">
                        <Row>
                          <div class="col-lg-12 col-md-12 col-sm-12  textaligmentcenter">
                            <img
                              className="imgmaretiqueta"
                              alt="logo"
                              src="assets/img/Logo/logon.png"
                            />
                          </div>
                          <div class="col-lg-12 col-md-12 col-sm-12 textaligmentcenter ">
                            <h1 class=" textaligmentcenter fontblackbold ">
                              BOON TEC INTERNATIONAL, S. de R.L. de C.V.
                            </h1>
                          </div>
                          <div class="col-lg-12 col-md-12 col-sm-12 margintop-16px textaligmentcenter">
                            <h3 class="  textaligmentcenter  fontblackbold ">
                              Norte 2 #14, Fracc. Cd. Industrial.H. Matamoros,
                              Mexico CP 87499
                            </h3>
                          </div>
                        </Row>
                        <div>
                          <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                            <Table className="bordersubtabla">
                              <Thead>
                                <Tr>
                                  <Th></Th>
                                  <Th></Th>
                                </Tr>
                              </Thead>
                              <Tbody>
                                <Tr>
                                  <Td
                                    colspan="2"
                                    className="fontsize50px textaligmentcenter"
                                  >
                                    <Label className="fontblackbold">
                                      MATERIAL NO CONFORME
                                    </Label>
                                  </Td>
                                </Tr>
                                <Tr>
                                  <Td className="fontsize50px textaligmentcenter">
                                    <Label className="fontblackbold">
                                      PART NO:
                                    </Label>
                                  </Td>
                                  <Td className="fontsize50px textaligmentcenter">
                                    <p className="floatleft fontblackbold subrayado ">
                                      {reciba.numerodeParte}
                                    </p>{" "}
                                  </Td>
                                </Tr>
                                <Tr>
                                  <Td className="fontsize50px textaligmentcenter">
                                    <Label className="  fontblackbold">
                                      DESCRIPTION:
                                    </Label>
                                  </Td>
                                  <Td className="fontsize50px textaligmentcenter">
                                    <p className="floatleft  fontblackbold">
                                      {reciba.descripcion}
                                    </p>
                                  </Td>
                                </Tr>
                                <Tr>
                                  <Td className="fontsize50px textaligmentcenter">
                                    <Label className="fontblackbold">
                                      MFG DATE:
                                    </Label>
                                  </Td>
                                  <Td className="fontsize50px textaligmentcenter">
                                    <p className="floatleft fontblackbold">
                                      {mRecibas.fechaDeReciba}
                                    </p>{" "}
                                  </Td>
                                </Tr>

                                <Tr>
                                  <Td className="fontsize50px textaligmentcenter">
                                    <Label className="fontblackbold">
                                      QUANTITY:
                                    </Label>
                                  </Td>
                                  <Td className="fontsize50px textaligmentcenter">
                                    <p className="floatleft fontblackbold">
                                      {cantidadAlmacen === false
                                        ? reciba.cantidadRecibida
                                        : reciba.piezasenCuarentena}
                                    </p>
                                  </Td>
                                </Tr>
                                <Tr>
                                  <Td className="fontsize50px textaligmentcenter">
                                    <Label className="fontblackbold">
                                      {reciba.cliente === "Olson Internacional"
                                        ? "LINE:"
                                        : "PACKING:"}
                                    </Label>
                                  </Td>
                                  <Td className="fontsize50px textaligmentcenter">
                                    <p className="floatleft fontblackbold">
                                      {reciba.packing}
                                    </p>
                                  </Td>
                                </Tr>
                                <Tr>
                                  <Td className="fontsize50px textaligmentcenter">
                                    <Label className="fontblackbold">
                                      LOT:
                                    </Label>
                                  </Td>
                                  <Td className="fontsize50px textaligmentcenter">
                                    <p className="floatleft fontblackbold">
                                      {reciba.lote}
                                    </p>
                                  </Td>
                                </Tr>
                                <Tr>
                                  <Td className="fontsize50px textaligmentcenter">
                                    <Label className="fontblackbold">
                                      CLIENT:
                                    </Label>
                                  </Td>
                                  <Td className="fontsize50px textaligmentcenter">
                                    <p className="floatleft fontblackbold">
                                      {reciba.cliente}
                                    </p>
                                  </Td>
                                </Tr>
                                <Tr>
                                  <Td className="fontsize50px textaligmentcenter">
                                    <Label className="fontblackbold">
                                      SERIAL NUMBER:
                                    </Label>
                                  </Td>
                                  <Td className="fontsize50px textaligmentcenter">
                                    <p className="floatleft fontblackbold">
                                      {reciba.serial === "ND"
                                        ? reciba.serialRecibaBTI + (Moment(reciba.fechaDeReciba).format("YYYY-MM-DD") < "2026-01-10" ? ((reciba.Ecoat || reciba.Pcoat) ? "-" : "") + (reciba.Ecoat === true ? "E" : "") + (reciba.Pcoat === true ? "P" : "") : "")
                                        : reciba.serial}
                                    </p>
                                  </Td>
                                </Tr>
                                <Tr>
                                  <Td className="fontsize50px textaligmentcenter">
                                    <Label className="fontblackbold">
                                      DEFECT:
                                    </Label>
                                  </Td>
                                  <Td className="fontsize50px textaligmentcenter">
                                    <p className="floatleft fontblackbold">
                                      {reciba.defectoCuarentena
                                        ? reciba.defectoCuarentena.toUpperCase()
                                        : ""}
                                    </p>
                                  </Td>
                                </Tr>
                                <Tr>
                                  <Td className="fontsize50px textaligmentcenter">
                                    <Label className="fontblackbold">
                                      INSPECTOR(S):
                                    </Label>
                                  </Td>
                                  <Td className="fontsize40px textaligmentcenter">
                                    <p className="floatleft fontblackbold">
                                      {reciba.quienInspecciono
                                        ? reciba.quienInspecciono.toUpperCase()
                                        : ""}
                                    </p>{" "}
                                  </Td>
                                </Tr>
                              </Tbody>
                            </Table>
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 textaligmentcenter mt-3">
                              <QRGenerator data={reciba.id} />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="efooter">
                        <p className="floatleft margintop-16px mr-3 fontsize40px fontblackbold">
                          Doc ID: FOR-QA66
                        </p>{" "}
                        <br />
                        <p className="floatright margintop-16px mr-3 fontsize40px fontblackbold">
                          Revisión: A
                        </p>{" "}
                        <br />
                      </div>
                    </>
                  )}
                {(reciba.piezasenAlmacen > 0 || tipo !== "parcial") && (
                  (llamada === "Almacén" || llamada === "Todo") && (
                    <>
                      <div className="page-breaksmtop">
                        <Row>
                          <div class="col-lg-12 col-md-12 col-sm-12  textaligmentcenter">
                            <img
                              className="imgmaretiqueta"
                              alt="logo"
                              src="assets/img/Logo/logon.png"
                            />
                          </div>
                          <div class="col-lg-12 col-md-12 col-sm-12 textaligmentcenter ">
                            <h1 class=" textaligmentcenter fontblackbold ">
                              BOON TEC INTERNATIONAL, S. de R.L. de C.V.
                            </h1>
                          </div>
                          <div class="col-lg-12 col-md-12 col-sm-12 margintop-16px textaligmentcenter">
                            <h3 class="  textaligmentcenter  fontblackbold ">
                              Norte 2 #14, Fracc. Cd. Industrial.H. Matamoros,
                              Mexico CP 87499
                            </h3>
                          </div>
                        </Row>
                        <div>
                          <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                            <Table className="bordersubtabla">
                              <Thead>
                                <Tr>
                                  <Th></Th>
                                  <Th></Th>
                                </Tr>
                              </Thead>
                              <Tbody>
                                <Tr>
                                  <Td className="fontsize50px textaligmentcenter">
                                    <Label className="fontblackbold">
                                      PART NO:
                                    </Label>
                                  </Td>
                                  <Td className="fontsize50px textaligmentcenter">
                                    <p className="floatleft fontblackbold subrayado ">
                                      {reciba.numerodeParte}
                                    </p>{" "}
                                  </Td>
                                </Tr>
                                <Tr>
                                  <Td className="fontsize50px textaligmentcenter">
                                    <Label className="  fontblackbold">
                                      DESCRIPTION:
                                    </Label>
                                  </Td>
                                  <Td className="fontsize50px textaligmentcenter">
                                    <p className="floatleft  fontblackbold">
                                      {reciba.descripcion}
                                    </p>
                                  </Td>
                                </Tr>
                                <Tr>
                                  <Td className="fontsize50px textaligmentcenter">
                                    <Label className="fontblackbold">
                                      MFG DATE:
                                    </Label>
                                  </Td>
                                  <Td className="fontsize50px textaligmentcenter">
                                    <p className="floatleft fontblackbold">
                                      {mRecibas.fechaDeReciba}
                                    </p>{" "}
                                  </Td>
                                </Tr>

                                <Tr>
                                  <Td className="fontsize50px textaligmentcenter">
                                    <Label className="fontblackbold">
                                      QUANTITY:
                                    </Label>
                                  </Td>
                                  <Td className="fontsize50px textaligmentcenter">
                                    <p className="floatleft fontblackbold">
                                      {cantidadAlmacen === false
                                        ? reciba.cantidadRecibida
                                        : reciba.piezasenAlmacen}
                                    </p>{" "}
                                  </Td>
                                </Tr>
                                <Tr>
                                  <Td className="fontsize50px textaligmentcenter">
                                    <Label className="fontblackbold">
                                      PO:
                                    </Label>
                                  </Td>
                                  <Td className="fontsize50px textaligmentcenter">
                                    <p className="floatleft fontblackbold">
                                      {reciba.po}
                                    </p>{" "}
                                  </Td>
                                </Tr>
                                <Tr>
                                  <Td className="fontsize50px textaligmentcenter">
                                    <Label className="fontblackbold">
                                      {reciba.cliente === "Olson Internacional"
                                        ? "LINE:"
                                        : "PACKING:"}
                                    </Label>
                                  </Td>
                                  <Td className="fontsize50px textaligmentcenter">
                                    <p className="floatleft fontblackbold">
                                      {reciba.packing}
                                    </p>{" "}
                                  </Td>
                                </Tr>
                                <Tr>
                                  <Td className="fontsize50px textaligmentcenter">
                                    <Label className="fontblackbold">
                                      LOT:
                                    </Label>
                                  </Td>
                                  <Td className="fontsize50px textaligmentcenter">
                                    <p className="floatleft fontblackbold">
                                      {reciba.lote}
                                    </p>{" "}
                                  </Td>
                                </Tr>
                                <Tr>
                                  <Td className="fontsize50px textaligmentcenter">
                                    <Label className="fontblackbold">
                                      CLIENT:
                                    </Label>
                                  </Td>
                                  <Td className="fontsize50px textaligmentcenter">
                                    <p className="floatleft fontblackbold">
                                      {reciba.cliente}
                                    </p>{" "}
                                  </Td>
                                </Tr>
                                <Tr>
                                  <Td className="fontsize50px textaligmentcenter">
                                    <Label className="fontblackbold">
                                      SERIAL NUMBER:
                                    </Label>
                                  </Td>
                                  <Td className="fontsize50px textaligmentcenter">
                                    <p className="floatleft fontblackbold">
                                      {reciba.serial === "ND"
                                        ? reciba.serialRecibaBTI + (Moment(reciba.fechaDeReciba).format("YYYY-MM-DD") < "2026-01-10" ? ((reciba.Ecoat || reciba.Pcoat) ? "-" : "") + (reciba.Ecoat === true ? "E" : "") + (reciba.Pcoat === true ? "P" : "") : "")
                                        : reciba.serial}
                                    </p>{" "}
                                  </Td>
                                </Tr>
                                <Tr>
                                  <Td className="fontsize50px textaligmentcenter">
                                    <Label className="fontblackbold">
                                      SERIAL BTI:
                                    </Label>
                                  </Td>
                                  <Td className="fontsize50px textaligmentcenter">
                                    <p className="floatleft fontblackbold">
                                      {reciba.serialRecibaBTI + (Moment(reciba.fechaDeReciba).format("YYYY-MM-DD") < "2026-01-10" ? ((reciba.Ecoat || reciba.Pcoat) ? "-" : "") + (reciba.Ecoat === true ? "E" : "") + (reciba.Pcoat === true ? "P" : "") : "")}
                                    </p>{" "}
                                  </Td>
                                </Tr>
                                <Tr>
                                  <Td className="fontsize50px textaligmentcenter">
                                    <Label className="fontblackbold">
                                      WEIGHT:
                                    </Label>
                                  </Td>
                                  <Td className="fontsize50px textaligmentcenter">
                                    <p className="floatleft fontblackbold">
                                      {reciba.peso ? reciba.peso + " Klg" : ""}
                                    </p>{" "}
                                  </Td>
                                </Tr>
                              </Tbody>
                            </Table>
                            <Row className="margintop300px"></Row>
                            <Row className="margintop100px"></Row>
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 textaligmentcenter  ">
                              <QRGenerator data={reciba.id} />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="efooter">
                        <Row >
                          <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                            <p className="floatleft   fontsize40px fontblackbold">
                              Doc ID: FOR-MA05
                            </p>
                          </div>
                          <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                            <p className="floatright   fontsize40px fontblackbold">
                              Revisión: A
                            </p>
                          </div>
                        </Row>
                      </div>
                    </>
                  )
                )}
              </div>
            )
          }
        </div>
      </div >
    </>
  );
}
export default EtiquetaViajeraPT;
